import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, m = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M26.956 20c0 1.74-3.114 6.087-6.956 6.087-3.842 0-6.957-4.348-6.957-6.087a6.956 6.956 0 0 1 13.913 0Z"
}, null, -1), Z = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M26.956 20a6.957 6.957 0 0 1-13.912 0"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "m27.373 26.15 1.844-1.845 1.23 1.23-1.845 1.844-1.229-1.23Zm-3.075 3.073 1.845-1.844 1.23 1.23-1.845 1.843-1.23-1.23Zm6.764.614 1.844-1.844 1.23 1.23-1.844 1.844-1.23-1.23Zm-3.075 3.075 1.845-1.844 1.23 1.23-1.845 1.843-1.23-1.23Zm1.23-4.919 1.845-1.844 1.23 1.23-1.845 1.844-1.23-1.23Zm-3.074 3.074 1.845-1.844 1.23 1.23-1.845 1.844-1.23-1.23Zm4.927-17.213-4.918-4.918 1.23-1.23 4.918 4.919-1.23 1.23Zm-4.919-1.229-1.844-1.844 1.23-1.23 1.844 1.845-1.23 1.23Zm3.074 3.075-1.844-1.844 1.23-1.23 1.843 1.844-1.229 1.23Zm.615-6.764-1.845-1.844 1.23-1.23 1.844 1.844-1.23 1.23Zm3.075 3.074-1.844-1.843 1.23-1.23 1.843 1.844-1.23 1.23ZM7.09 27.99l4.918 4.918-1.23 1.23-4.917-4.918 1.23-1.23Zm4.918 1.228 1.845 1.845-1.23 1.23-1.844-1.845 1.23-1.23Zm-3.074-3.073 1.844 1.845-1.23 1.23-1.843-1.845 1.23-1.23Zm1.844-1.845 4.919 4.918-1.23 1.23L9.55 25.53l1.23-1.23Zm1.23-17.212L7.09 12.006l-1.23-1.23 4.918-4.918 1.23 1.23Zm1.844 1.844L8.934 13.85l-1.23-1.23 4.919-4.918 1.23 1.23Zm1.846 1.845-4.918 4.918-1.23-1.229 4.919-4.918 1.23 1.23Z"
}, null, -1), c = [
  m,
  n,
  Z,
  s
];
function d(i, _) {
  return l(), e("svg", o, [...c]);
}
const r = { render: d };
export {
  r as default,
  d as render
};
